// extracted by mini-css-extract-plugin
export default {"Sidebar":"Sidebar_Sidebar__9tQdf","OpenSidebar":"Sidebar_OpenSidebar__t4KIV","CloseSidebar":"Sidebar_CloseSidebar__KiAbt"};